<template>
  <div class="login-container">
    <el-row v-if="isMobile === false">
      <el-col :span="16">
        <div class="login-left">
          <img :src="ieshopLogo" alt="ieShop" class="logo" />
          <h3 class="title">Welcome to the <br> IE Shop Admin System</h3>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="login-right">
          <el-form
            autocomplete="on"
            :model="loginForm"
            :rules="rules"
            ref="loginForm"
            label-position="left"
            label-width="0px"
            class="card-box login-form"
          >
            <h3 class="login-form-title">Merchant System</h3>
            <el-form-item prop="username">
              <span class="svg-container svg-container_login">
                <svg-icon icon-class="user" />
              </span>
              <el-input
                name="username"
                class="inputfield"
                type="text"
                v-model="loginForm.username"
                autocomplete="on"
                placeholder="Login Name"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <span class="svg-container">
                <svg-icon icon-class="password"></svg-icon>
              </span>
              <el-input
                name="password"
                :type="pwdType"
                @keyup.enter.native="handleLogin"
                v-model="loginForm.password"
                autocomplete="on"
                placeholder="Password"
              ></el-input>
              <span class="show-pwd" @click="showPwd">
                <svg-icon icon-class="eye" />
              </span>
            </el-form-item>
            <el-form-item>
              <el-button
                type="danger"
                size="medium"
                style="width:100%; font-size: 22px;"
                :loading="loading"
                @click.native.prevent="handleLogin"
              >Sign in</el-button>
            </el-form-item>
            <div class="password-signup">
              <a style="float: left; color: #409EFF;" @click="forgotPasswordClick">Forgot password?</a>
              <span style="float: right;">
                Don't have an account yet?
                <a style="color: #409EFF;" @click="goToSignup">Sign up</a>
              </span>
            </div>
          </el-form>
          <div class="copyright">Copyright © 2021 IE Shop. All rights reserved.</div>
        </div>
      </el-col>
    </el-row>
    <div v-else class="mobile-login">
      <el-form
        autocomplete="on"
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        label-position="left"
        label-width="0px"
        class="login-form"
      >
        <img :src="ieshopLogo" alt="IeShop" style="height: 50px;" />
        <div class="login-form-title">IE Shop Merchant Admin System</div>
        <el-form-item prop="username">
          <span class="svg-container svg-container_login">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            name="username"
            class="inputfield"
            type="text"
            v-model="loginForm.username"
            autocomplete="on"
            placeholder="Login Name"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password"></svg-icon>
          </span>
          <el-input
            name="password"
            :type="pwdType"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.password"
            autocomplete="on"
            placeholder="Password"
          ></el-input>
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye" />
          </span>
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            size="medium"
            style="width:100%; font-size: 22px;"
            :loading="loading"
            @click.native.prevent="handleLogin"
          >Sign in</el-button>
        </el-form-item>
        <div class="password-signup">
          <a style="float: left; color: #409EFF;" @click="mobileGoToSignup">Forgot password?</a>
          <span style="float: right;">
            Don't have an account?
            <a style="color: #409EFF;" @click="goToSignup">Sign up</a>
          </span>
        </div>
      </el-form>
    </div>

    <el-dialog
      title="Forgot password?"
      :visible.sync="forgotPasswordDialogVisible"
      width="40%"
      :append-to-body="true"
    >
      <el-form ref="resetPasswordForm" :model="resetPasswordForm" style="padding: 0 20px;">
        <el-form-item label="Email address" prop="email">
          <el-input v-model="resetPasswordForm.email" placeholder="Enter your email"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 40px;">
          <div style="text-align: center;">
            <el-button
              type="primary"
              @click="resetPassword()"
              style="width: 260px; font-size: 18px;"
            >Reset Password</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="Forgot password?"
      :visible.sync="mobileForgotPasswordDialogVisible"
      width="90%"
      :append-to-body="true"
    >
      <el-form ref="resetPasswordForm" :model="resetPasswordForm">
        <el-form-item label="Email address" prop="email">
          <el-input v-model="resetPasswordForm.email" placeholder="Enter your email"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 30px;">
          <div style="text-align: center;">
            <el-button
              type="primary"
              @click="resetPassword()"
              style="width: 100%; font-size: 16px;"
            >Reset Password</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { menu } from '@/utils/menu'
import cookie from 'js-cookie'
import request from '@/utils/request'
import ieshopLogo from '@/assets/img/ieshop_single_logo.png'

export default {
  name: 'login',
  data() {
    return {
      ieshopLogo: ieshopLogo,
      isMobile: false,
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur,change'
          }
        ],
        password: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          },
          {
            min: 6,
            max: 32,
            message: this.generateCustomizeString('between6To32Char'),
            trigger: 'blur'
          }
        ]
      },
      loading: false,
      pwdType: 'password',
      dialogVisible: false,
      forgotPasswordDialogVisible: false,
      mobileForgotPasswordDialogVisible: false,
      resetPasswordForm: {
        email: ''
      }
    }
  },
  created() {
    this.setDefaultLanguage()
    this.checkMobile()
  },
  methods: {
    generateCustomizeString,
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
      console.log(this.isMobile)
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('Login', this.loginForm)
            .then(() => {
              this.loading = false
              Promise.all([this.$store.dispatch('GetInfo'), this.$store.dispatch('SetShopBasic')])
                .then(res => {
                  const globalMenu = {}
                  globalMenu['isCouponEnabled'] = this.$store.getters.is_coupon_enabled === 1
                  globalMenu['isAgencyEnabled'] = this.$store.getters.is_agency_enabled === 1
                  cookie.set('globalMenu', JSON.stringify(globalMenu))
                  this.$router.addRoutes(menu(globalMenu))
                  this.$router.push({ path: '/' })
                })
                .catch(async(error) => {
                  console.log(error)
                  this.$store.dispatch('FedLogOut').then(() => {
                    this.$message.error('验证失败,请重新登录')
                    this.$router.push({ path: '/login' })
                  })
                })
            })
            .catch(async(err) => {
              this.loading = false
              if (!err) {
                err = 'Login falied, please try again.'
              }
              if (err == '非商店用户') {
                this.$message.warning('It is not merchant account')
              } else {
                this.$message.warning(err)
              }
              return false
            })
        } else {
          return false
        }
      })
    },
    goToSignup() {
      window.location.href = 'https://ieshop.co.nz/home/register'
      // this.$router.push({
      //   path: '/register'
      // })
    },
    forgotPasswordClick() {
      this.$router.push({
        path: '/forgot-password'
      })
    },
    mobileGoToSignup() {
      this.$router.push({
        path: '/forgot-password'
      })
    },
    setDefaultLanguage() {
      let lang = ''

      if (this.$route.query.lang) {
        lang = this.$route.query.lang
      } else if (location.host.includes('ieshop.co.nz')) {
        lang = 'en'
      }

      if (lang === 'en' || lang === 'zh') {
        this.setLanguage(lang)
      }
    },
    setLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
    },
    resetPassword() {
      const emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      // 如果邮箱格式错误
      if (!emailPattern.test(this.resetPasswordForm.email)) {
        this.$message({
          message: 'Invalid email format',
          type: 'warning'
        })
        return
      }

      var data = {
        email: this.resetPasswordForm.email
      }

      request({
        url: '/reset-password',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: 'Password reset email has been sent!',
              type: 'success'
            })
            this.resetPasswordForm.email = ''
            this.forgotPasswordDialogVisible = false
            this.mobileForgotPasswordDialogVisible = false
          } else {
            this.$message.error(res.error)
            this.forgotPasswordDialogVisible = false
            this.mobileForgotPasswordDialogVisible = false
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('Password reset email sent failed!')
          this.forgotPasswordDialogVisible = false
          this.mobileForgotPasswordDialogVisible = false
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
// @import 'src/styles/mixin.scss';
// $bg: #60a65f;
$bg: #d4edf4;
$dark_gray: #fff;
$light_gray: #eee;

.login-container {
  // @include relative;
  height: 100vh;
  // background-color: $bg;
  input:-webkit-autofill {
    // -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
    background-color: #f56c6c !important;
    transition: background-color 5000s ease-in-out 0s;
  }
  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: $light_gray;
    height: 47px;
    font-size: 16px;
  }
  .login-left {
    background-image: url(https://img.nzmai.com.cn/iemall_login_bg.jpg);
    background-size: cover;
    height: 100vh;
  }
  .login-right {
    background-color: #212326;
    height: 100vh;
    display: flex;
    align-items: center;
  }
  .login-form-title {
    color: #fff;
    font-size: 2.2rem;
    margin-bottom: 50px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .logo {
    height: 50px;
    margin-top: 30px;
    margin-left: 30px;
  }
  .title {
    margin: 200px auto !important;
    padding-right: 30px;
    font-size: 2.8rem;
    font-weight: 500;
    color: #000;
    margin: 0px auto 40px auto;
    text-align: right;
    line-height: 60px;
  }
  .login-form {
    padding-bottom: 100px;
    // position: absolute;
    // left: 0;
    // right: 0;
    width: 400px;
    // padding: 35px 35px 15px 35px;
    // margin: 120px auto;
    text-align: center;
    margin: auto;
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }
  .el-input__inner {
    color: #66b1ff;
  }
  .agree {
    margin-bottom: 22px;
    a {
      font-size: 16px;
      text-decoration: underline;
      margin-right: 5px;
    }
  }
  .mobile-login {
    padding-top: 80px;
    height: 100vh;
    background-color: #212326;
    .login-form {
      width: 90%;
      text-align: center;
    }
    .login-form-title {
      color: #fff;
      font-size: 1.8rem;
      font-weight: 500;
      margin-top: 50px;
      margin-bottom: 30px;
    }
  }
  .copyright {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px 20px;
    color: #fff;
  }
  .password-signup {
    margin-top: -10px;
    font-size: 13px;
    color: #aaa;
  }
}
</style>
